import React from 'react';
import { Link } from 'react-router-dom';
// import $, { data } from 'jquery';
// import Swal from 'sweetalert2';
// import Toggle from 'react-toggle';
// import { useDispatch } from 'react-redux';
// import axios from 'axios';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import { GetServiceFilter } from '../../actions/homeAction';
import PropTypes from 'prop-types';
import {
  getTaxiData,
  SparePartsGetList,
  getcardealerListing,
  getcarsaleListing,
  getCarRentListing,
  getGarageData,
  getCarWashListing,
  getcarInsuranceListing,
  getdrivingSchoolListing,
  getcarProtectionListing,
  getairConditioningListing,
  getquickServiceOwnerListing,
  getCarTowingData,
  updateGarageStatus,
  updateBusinessStatus,
  deleteCarSale,
} from '../../actions/homeAction';
import { createMuiTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { FaEdit, FaEye, FaTrashAlt, FaCalendarPlus } from 'react-icons/fa';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import moment from 'moment';
// import {
// 	FormGroup,
// 	FormLabel,
// 	TextField,
// 	Button,
// 	Tooltip,
// 	Select,
// 	FormControl,
// 	InputLabel,
// } from '@material-ui/core';
// import { GET_SERVICE_FILTER } from '../../actions/types';

class ProductList extends React.Component {
  state = {
    serviceFilter: {},
  };
  componentWillReceiveProps(nextProps) {
    this.setState({
      home: nextProps.home,
    });
  }

  // componentDidMount() {
  // 	this.props.getGarageData();
  // 	this.props.getTaxiData();
  // }

  handleServiceChange = (data) => {
    this.setState({ serviceFilter: data });
    console.log('hendler >>>>>>', data);
    console.log(this.state.serviceFilter);

    console.log(this.state.serviceFilter);
  };

  componentDidMount() {
    if (this.props.match.params.type === 'Garage') {
      this.props.getGarageData();
    } else if (this.props.match.params.type === 'SpareParts') {
      this.props.SparePartsGetList();
    } else if (this.props.match.params.type === 'CarDealers') {
      this.props.getcardealerListing();
    } else if (this.props.match.params.type === 'CarForSale') {
      this.props.getcarsaleListing();
    } else if (this.props.match.params.type === 'RentCar') {
      this.props.getCarRentListing();
    } else if (this.props.match.params.type === 'CarWash') {
      this.props.getCarWashListing();
    } else if (this.props.match.params.type === 'Taxi') {
      this.props.getTaxiData();
    } else if (this.props.match.params.type === 'CarTowing') {
      this.props.getCarTowingData();
    } else if (this.props.match.params.type === 'CarInsurance') {
      this.props.getcarInsuranceListing();
      // this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'DrivingSchool') {
      this.props.getdrivingSchoolListing();
      // this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarProtection') {
      this.props.getcarProtectionListing();
      // this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarConditioning') {
      this.props.getairConditioningListing();
      // this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'QuickService') {
      this.props.getquickServiceOwnerListing();
      // this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarsAgent') {
      // this.props.GetServiceFilter(serviceType);
    }
  }

  onGo = () => {
    var serviceType =
      this.state.serviceFilter !== 'All' ? this.state.serviceFilter : '';

    // var serviceType = this.state.serviceFilter !== 'All' ? this.state.serviceFilter : '';

    console.log(serviceType);
    if (this.props.match.params.type === 'Garage') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'SpareParts') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarDealers') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarForSale') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'RentCar') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'Taxi') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarWash') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarTowing') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarInsurance') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'DrivingSchool') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarProtection') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarConditioning') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'QuickService') {
      this.props.GetServiceFilter(serviceType);
    } else if (this.props.match.params.type === 'CarsAgent') {
      this.props.GetServiceFilter(serviceType);
    }
  };

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTable: {
          responsiveStacked: {
            maxHeight: '35vh',
            overflowX: 'none',
          },
        },
        MUIDataTableHeadCell: {
          root: {
            width: '80px',
            fontWeight: 'bold',
            padding: '5px',
            lineHeight: '10px',
            whiteSpace: 'normal',
            overflow: 'hidden',
            //           wordWrap: "break-word",
            fontSize: '10px',
          },
        },
        MUIDataTableBodyCell: {
          root: {
            width: '80px',
            fontSize: '9px', // border:'1px solid black',
            padding: '5px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          },
        },
      },
    });

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (this.props.match.params.type === 'Garage') {
        this.props.getGarageData();
      } else if (this.props.match.params.type === 'SpareParts') {
        this.props.SparePartsGetList();
      } else if (this.props.match.params.type === 'CarDealers') {
        this.props.getcardealerListing();
      } else if (this.props.match.params.type === 'CarForSale') {
        this.props.getcarsaleListing();
      } else if (this.props.match.params.type === 'RentCar') {
        this.props.getCarRentListing();
      } else if (this.props.match.params.type === 'CarWash') {
        this.props.getCarWashListing();
      } else if (this.props.match.params.type === 'Taxi') {
        this.props.getTaxiData();
      } else if (this.props.match.params.type === 'CarTowing') {
        this.props.getCarTowingData();
      } else if (this.props.match.params.type === 'CarInsurance') {
        this.props.getcarInsuranceListing();
      } else if (this.props.match.params.type === 'DrivingSchool') {
        this.props.getdrivingSchoolListing();
      } else if (this.props.match.params.type === 'CarProtection') {
        this.props.getcarProtectionListing();
      } else if (this.props.match.params.type === 'CarConditioning') {
        this.props.getairConditioningListing();
      } else if (this.props.match.params.type === 'QuickService') {
        this.props.getquickServiceOwnerListing();
      } else if (this.props.match.params.type === 'CarsAgent') {
      } else if (this.props.match.params.type) {
      }
    }
  }

  // Re-fetch the current category's list (used after a status toggle).
  refetchByType = () => {
    const t = this.props.match.params.type;
    const map = {
      Garage: this.props.getGarageData,
      SpareParts: this.props.SparePartsGetList,
      CarDealers: this.props.getcardealerListing,
      CarForSale: this.props.getcarsaleListing,
      RentCar: this.props.getCarRentListing,
      Taxi: this.props.getTaxiData,
      CarWash: this.props.getCarWashListing,
      CarTowing: this.props.getCarTowingData,
      CarInsurance: this.props.getcarInsuranceListing,
      DrivingSchool: this.props.getdrivingSchoolListing,
      CarProtection: this.props.getcarProtectionListing,
      CarConditioning: this.props.getairConditioningListing,
      QuickService: this.props.getquickServiceOwnerListing,
    };
    if (map[t]) map[t]();
  };

  // Account Owner cell linking to the owner's profile (ownerId hidden at rowData[1]).
  ownerLinkCell = (accountOwner, tableMeta) => {
    const ownerId = tableMeta?.rowData?.[1];
    if (ownerId) {
      return <Link to={`/user/view/${ownerId}`}>{accountOwner}</Link>;
    }
    return <span>{accountOwner}</span>;
  };

  // Reusable active/inactive toggle cell for any category (status is the hidden
  // column at rowData[3] in the shared column block).
  statusToggleCell = (businessId, tableMeta) => {
    const status = tableMeta?.rowData?.[3];
    const isActive = status === 'active';
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
        <Toggle
          checked={isActive}
          icons={false}
          onChange={() =>
            this.props.updateBusinessStatus(
              this.props.match.params.type,
              businessId,
              isActive ? 'in-active' : 'active',
              () => setTimeout(this.refetchByType, 400)
            )
          }
        />
        <Link
          to={`/assign-plan/${this.props.match.params.type}/${businessId}`}
          title="Assign / Extend Plan"
          style={{ color: '#3ab1f7' }}
        >
          <FaCalendarPlus style={{ fontSize: '1.15rem' }} />
        </Link>
      </div>
    );
  };

  render() {
    // var paths = this.props.match.params.type;
    let columns = [];

    if (
      this.props.match.params.type === 'Garage' ||
      // this.props.match.params.type === 'CarForSale' ||
      // this.props.match.params.type === 'SpareParts' ||
      // this.props.match.params.type === 'CarDealers' ||
      this.props.match.params.type === 'RentCar' ||
      this.props.match.params.type === 'CarWash' ||
      this.props.match.params.type === 'CarInsurance' ||
      this.props.match.params.type === 'CarProtection' ||
      this.props.match.params.type === 'CarConditioning' ||
      this.props.match.params.type === 'DrivingSchool' ||
      this.props.match.params.type === 'QuickService'
    ) {
      columns = [
        {
          name: 'accountOwner',
          label: 'Account Owner',

          options: {
            filter: false,
            sort: false,
            customBodyRender: (accountOwner, tableMeta) => {
              // Hidden helper columns sit at rowData[1]=ownerId, [2]=businessId.
              const ownerId = tableMeta?.rowData?.[1];
              const bizId = tableMeta?.rowData?.[2];
              if (ownerId) {
                return (
                  <Link to={`/user/view/${ownerId}`}>{accountOwner}</Link>
                );
              }
              return <span>{accountOwner}</span>;
            },
          },
        },
        {
          name: 'accountOwnerId',
          label: 'ownerId',
          options: { display: false, filter: false, sort: false },
        },
        {
          name: 'garageOwnerId',
          label: 'bizId',
          options: { display: false, filter: false, sort: false },
        },
        {
          name: 'status',
          label: 'statusHidden',
          options: { display: false, filter: false, sort: false },
        },
        {
          name: 'carInsuranceName',
          label: 'Insurance Name',

          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'CarInsurance'
                ? 'true'
                : 'excluded',
          },
        },
        {
          name: 'carWashName',
          label: 'Car Wash Name',

          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'CarWash' ? 'true' : 'excluded',
          },
        },
        {
          name: 'drivingSchoolName',
          label: 'Driving School Name',

          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'DrivingSchool'
                ? 'true'
                : 'excluded',
          },
        },
        {
          name: 'carProtectionName',
          label: 'Car Protection Name',

          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'CarProtection'
                ? 'true'
                : 'excluded',
          },
        },
        {
          name: 'quickServiceOwnerName',
          label: 'Quick Service Name',

          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'QuickService'
                ? 'true'
                : 'excluded',
          },
        },
        {
          name: 'garageName',
          label: 'Garage Name',

          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'Garage' ? 'true' : 'excluded',
          },
        },
        {
          name: 'mobileNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'createdAt',
          label: 'Date of Registration',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (createdAt) => {
              return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
            },
          },
        },
        {
          name: 'currentSubscription',
          label: 'Membership Expiry',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (currentSubscription) => {
              return currentSubscription.expiry
                ? moment(currentSubscription.expiry).format(
                    'DD/MM/YYYY , hh:mm A'
                  )
                : 'N/A';
            },
          },
        },
        {
          name: 'daysLeft',
          label: 'Membership Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (daysLeft, tableMeta) => {
              return <div>{daysLeft ? 'Active' : 'Expired'}</div>;
            },
          },
        },
        {
          name: 'status',
          label: 'Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (status, tableMeta) => {
              switch (status) {
                case 'active':
                  return <div className="st-active">Active</div>;
                case 'in-active':
                  return <div className="st-inactive">Inactive</div>;
                default: //status === delete
                  return <div className="text-danger">Deleted</div>;
              }
            },
          },
        },
        {
          name: 'garageOwnerId',
          label: 'Active',
          options: {
            filter: false,
            sort: false,
            display:
              this.props.match.params.type === 'Garage' ? 'true' : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'carRentId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'RentCar' ? 'true' : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'carWashId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'CarWash' ? 'true' : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'carInsuranceId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'CarInsurance'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'carProtectionId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'CarProtection'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'airConditioningId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'CarConditioning'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'drivingSchoolId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'DrivingSchool'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'quickServiceOwnerId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'QuickService'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        // {
        //   name: 'carRentName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'RentCar' ? 'true' : 'excluded',
        //   },
        // },
        // {
        //   name: 'sparePartOwnerName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'SpareParts'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'carDealerName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'CarDealers'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'carWashName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'CarWash' ? 'true' : 'excluded',
        //   },
        // },

        // {
        //   name: 'carInsuranceName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'CarInsurance'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'drivingSchoolName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'DrivingSchool'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'carProtectionName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'CarProtection'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'airConditioningName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'CarConditioning'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'quickServiceOwnerName',
        //   label: 'Business Name',

        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type === 'QuickService'
        //         ? 'true'
        //         : 'excluded',
        //   },
        // },

        // {
        //   name: 'businessMedia',
        //   label: 'Business Logo',
        //   options: {
        //     filter: false,
        //     sort: false,
        //     customBodyRender: (businessMedia, tableMeta) => {
        //       console.log('businessMedia', businessMedia);
        //       return (
        //         <img
        //           loading="lazy"
        //           style={{
        //             width: '2.5rem',
        //             height: '2.5rem',
        //             borderRadius: '50%',
        //           }}
        //           src={
        //             businessMedia[0] !== undefined &&
        //             businessMedia[0] !== null &&
        //             businessMedia[0] !== ''
        //               ? businessMedia[0]?.media?.path
        //               : './assets/images/icon.png'
        //           }
        //           className="img-fluid img-60"
        //           alt=""
        //           onError={this.imgLoadError}
        //         />
        //       );
        //     },
        //   },
        // },
        // {
        //   name: 'packages',
        //   label: 'Business Package',
        //   options: {
        //     filter: false,
        //     sort: true,
        //     display:
        //       this.props.match.params.type !== 'Garage' ? 'true' : 'excluded',
        //     customBodyRender: (packages, tableMeta) => {
        //       return (
        //         <div>
        //           {packages?.map((dt, i) => (
        //             <>
        //               {dt?.packageName}&nbsp;{dt?.price}
        //               <br />
        //             </>
        //           ))}
        //         </div>
        //       );
        //     },
        //   },
        // },

        // {
        //   name: 'about',
        //   label: 'Brand',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },

        // {
        // 	name: 'gps',
        // 	label: 'GPS',
        // 	options: {
        // 		filter: false,
        // 		sort: true,
        // 		customBodyRender: (packageNew) => {
        // 			console.log("packagepackage", packageNew)
        // 			return(
        // 				<div>
        // 					<span>Lat : {Math.round(packageNew?.lat * 100)/100}</span> &nbsp;
        // 					<span>Long : {Math.round(packageNew?.long * 100)/100}</span>
        // 				</div>
        // 			)
        // 		}
        // 	},
        // },

        // {
        //   name: 'location',
        //   label: 'Location',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },

        // {
        // 	name: 'carWashId',
        // 	label: 'Actions',
        // 	options: {
        // 		filter: false,
        // 		sort: true,
        // 		customBodyRender: (sparePartId) => {
        // 			return(
        // 				<div>
        // 					<Link to={`/ServiceProviders/CarWash/Update/${sparePartId}`}>
        // 						<FaEdit style={{fontSize: '1.4rem'}} />
        // 					</Link>
        // 				</div>
        // 			)
        // 		}
        // 	},
        // },
      ];
    }

    // Service Providers-> Car Dealers
    else if (this.props.match.params.type === 'CarDealers') {
      columns = [
        {
          name: 'accountOwner',
          label: 'Account Owner',
          options: {
            filter: false,
            sort: false,
            customBodyRender: this.ownerLinkCell,
          },
        },
        { name: 'accountOwnerId', label: 'ownerId', options: { display: false, filter: false, sort: false } },
        { name: 'carDealerId', label: 'bizId', options: { display: false, filter: false, sort: false } },
        { name: 'status', label: 'statusHidden', options: { display: false, filter: false, sort: false } },
        {
          name: 'carDealerName',
          label: 'Name',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'mobileNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'createdAt',
          label: 'Date of Registration',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (createdAt) => {
              return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
            },
          },
        },
        {
          name: 'currentSubscription',
          label: 'Membership Expiry',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (currentSubscription) => {
              return currentSubscription.expiry
                ? moment(currentSubscription.expiry).format(
                    'DD/MM/YYYY , hh:mm A'
                  )
                : 'N/A';
            },
          },
        },
        {
          name: 'daysLeft',
          label: 'Membership Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (daysLeft, tableMeta) => {
              return <div>{daysLeft ? 'Active' : 'Expired'}</div>;
            },
          },
        },
        {
          name: 'status',
          label: 'Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (status, tableMeta) => {
              switch (status) {
                case 'active':
                  return <div className="st-active">Active</div>;
                case 'in-active':
                  return <div className="st-inactive">Inactive</div>;
                default:
                  return <div className="text-danger">Deleted</div>;
              }
            },
          },
        },
        // {
        //   name: 'businessMedia',
        //   label: 'Business Logo',
        //   options: {
        //     filter: false,
        //     sort: false,
        //     customBodyRender: (businessMedia, tableMeta) => {
        //       console.log('businessMedia', businessMedia);
        //       return (
        //         <img
        //           loading="lazy"
        //           style={{
        //             width: '2rem',
        //             height: '2rem',
        //             borderRadius: '2rem',
        //           }}
        //           src={
        //             businessMedia[0] !== undefined
        //               ? businessMedia[0]?.media?.path
        //               : './assets/images/icon.png'
        //           }
        //           className="img-fluid img-60"
        //           alt=""
        //           onError={this.imgLoadError}
        //         />
        //       );
        //     },
        //   },
        // },
        // {
        //   name: 'about',
        //   label: 'About',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },
        // {
        //   name: 'location',
        //   label: 'Location',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },

        {
          name: 'carDealerId',
          label: 'Active',
          display:
            this.props.match.params.type === 'CarDealers' ? 'true' : 'excluded',
          options: {
            filter: false,
            sort: true,
            customBodyRender: this.statusToggleCell,
          },
        },
      ];
    }

    // Service Providers-> Spare Parts
    else if (this.props.match.params.type === 'SpareParts') {
      columns = [
        {
          name: 'accountOwner',
          label: 'Account Owner',
          options: {
            filter: false,
            sort: true,
            customBodyRender: this.ownerLinkCell,
          },
        },
        { name: 'accountOwnerId', label: 'ownerId', options: { display: false, filter: false, sort: false } },
        { name: 'sparePartsId', label: 'bizId', options: { display: false, filter: false, sort: false } },
        { name: 'status', label: 'statusHidden', options: { display: false, filter: false, sort: false } },
        {
          name: 'sparePartOwnerName',
          label: 'Name',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'mobileNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'createdAt',
          label: 'Date of Registration',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (createdAt) => {
              return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
            },
          },
        },
        {
          name: 'currentSubscription',
          label: 'Membership Expiry',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (currentSubscription) => {
              return currentSubscription.expiry
                ? moment(currentSubscription.expiry).format(
                    'DD/MM/YYYY , hh:mm A'
                  )
                : 'N/A';
            },
          },
        },
        {
          name: 'daysLeft',
          label: 'Membership Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (daysLeft, tableMeta) => {
              return (
                <div className="text-center">
                  {daysLeft ? 'Active' : 'Expired'}
                </div>
              );
            },
          },
        },
        {
          name: 'status',
          label: 'Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (status, tableMeta) => {
              switch (status) {
                case 'active':
                  return <div className="st-active">Active</div>;
                case 'in-active':
                  return <div className="st-inactive">Inactive</div>;
                default:
                  return <div className="text-danger">Deleted</div>;
              }
            },
          },
        },
        // {
        //   name: 'businessMedia',
        //   label: 'Business Logo',
        //   options: {
        //     filter: false,
        //     sort: false,
        //     customBodyRender: (businessMedia, tableMeta) => {
        //       console.log('businessMedia', businessMedia);
        //       return (
        //         <img
        //           loading="lazy"
        //           style={{
        //             width: '2rem',
        //             height: '2rem',
        //             borderRadius: '2rem',
        //           }}
        //           src={
        //             businessMedia[0] !== undefined
        //               ? businessMedia[0]?.media?.path
        //               : './assets/images/icon.png'
        //           }
        //           className="img-fluid img-60"
        //           alt=""
        //           onError={this.imgLoadError}
        //         />
        //       );
        //     },
        //   },
        // },
        // {
        //   name: 'about',
        //   label: 'About',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },

        // {
        //   name: 'location',
        //   label: 'Location',
        //   options: {
        //     filter: false,
        //     sort: true,
        //   },
        // },
        {
          name: 'sparePartsId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            customBodyRender: this.statusToggleCell,
          },
        },
      ];
    }

    // Service Providers-> Cars For Sale
    else if (this.props.match.params.type === 'CarForSale') {
      columns = [
        { name: 'status', label: 'statusHidden', options: { display: false, filter: false, sort: false } },
        {
          name: 'brand.name',
          label: 'Car Brand',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'carModel',
          label: 'Car Model and Series',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'description',
          label: 'Car Description',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'price',
          label: 'Price',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'mobileNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'kilometerDriven',
          label: 'Kilometer Driven',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'modelYear.modelYear',
          label: 'Model Year',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'fuelType.fuelType',
          label: 'Fuel Type',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'interiorColor.color',
          label: 'Interior Color',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'status',
          label: 'Status',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (status) => {
              return (
                <div
                  className={status === 'active' ? 'st-active' : 'st-inactive'}
                >
                  {status === 'active' ? 'Active' : 'In-Active'}
                </div>
              );
            },
          },
        },

        {
          name: 'carSaleId',
          label: 'Actions',
          options: {
            filter: false,
            sort: false,
            customBodyRender: (carSaleId, tableMeta) => {
              const status = tableMeta?.rowData?.[0];
              const isActive = status === 'active';
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                  <Link to={`/cars-for-sale/view/${carSaleId}`} title="View">
                    <FaEye style={{ fontSize: '1.3rem' }} />
                  </Link>
                  <Toggle
                    checked={isActive}
                    icons={false}
                    onChange={() =>
                      this.props.updateBusinessStatus(
                        'CarForSale',
                        carSaleId,
                        isActive ? 'in-active' : 'active',
                        () => setTimeout(this.refetchByType, 400)
                      )
                    }
                  />
                  <FaTrashAlt
                    style={{ fontSize: '1.1rem', cursor: 'pointer', color: '#d33' }}
                    title="Delete"
                    onClick={() => {
                      if (window.confirm('Delete this car-for-sale post?')) {
                        this.props.deleteCarSale(carSaleId, () =>
                          setTimeout(this.refetchByType, 400)
                        );
                      }
                    }}
                  />
                </div>
              );
            },
          },
        },
      ];
    }

    // Service Providers-> Taxi/Car Towing
    else if (
      this.props.match.params.type === 'CarTowing' ||
      this.props.match.params.type === 'Taxi'
    ) {
      columns = [
        {
          name: 'user',
          label: 'Account Owner',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (user, tableMeta) => {
              const name = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
              if (user?.userId) {
                return <Link to={`/user/view/${user.userId}`}>{name || user?.username}</Link>;
              }
              return <div>{name}</div>;
            },
          },
        },
        { name: 'accountOwnerId', label: 'ownerId', options: { display: false, filter: false, sort: false } },
        { name: 'taxiOwnerId', label: 'bizId', options: { display: false, filter: false, sort: false } },
        { name: 'status', label: 'statusHidden', options: { display: false, filter: false, sort: false } },
        {
          name:
            this.props.match.params.type === 'Taxi'
              ? 'taxiCompanyName'
              : 'towingCompanyName',
          label: 'Company Name',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'carDetails',
          label: 'Car Brand',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (carDetails, tableMeta) => {
              return <div>{carDetails?.name}</div>;
            },
          },
        },

        {
          name: 'plateNumber',
          label: 'Plate Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'mobileNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'createdAt',
          label: 'Date of Registration',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (createdAt) => {
              return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
            },
          },
        },
        {
          name: 'currentSubscription',
          label: 'Membership Expiry',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (currentSubscription) => {
              return currentSubscription.expiry
                ? moment(currentSubscription.expiry).format(
                    'DD/MM/YYYY , hh:mm A'
                  )
                : 'N/A';
            },
          },
        },
        {
          name: 'daysLeft',
          label: 'Membership Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (daysLeft, tableMeta) => {
              return <div>{daysLeft ? 'Active' : 'Expired'}</div>;
            },
          },
        },
        {
          name: 'status',
          label: 'Status',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (status, tableMeta) => {
              switch (status) {
                case 'active':
                  return <div className="st-active">Active</div>;
                case 'in-active':
                  return <div className="st-inactive">Inactive</div>;
                default:
                  return <div className="text-danger">Deleted</div>;
              }
            },
          },
        },
        {
          name: 'taxiOwnerId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'Taxi' ? 'true' : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
        {
          name: 'towingOwnerId',
          label: 'Active',
          options: {
            filter: false,
            sort: true,
            display:
              this.props.match.params.type === 'CarTowing'
                ? 'true'
                : 'excluded',
            customBodyRender: this.statusToggleCell,
          },
        },
      ];
    }
    // Service Providers-> Driving School
    // } else if (this.props.match.params.type === 'DrivingSchool') {
    // 	columns = [
    // 		{
    // 			name: 'BusinessName',
    // 			label: 'Business Name',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'ServiceType',
    // 			label: 'Service Type',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BusinessLogo',
    // 			label: 'Business Logo',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'PhoneNumber',
    // 			label: 'Phone Number',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'WhatsappNumber',
    // 			label: 'Whatsapp Number',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BusinessCategory',
    // 			label: 'Business Category',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'AboutCompany',
    // 			label: 'About the Company',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'SelectLocationMap',
    // 			label: 'Select Location on Map',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Gender',
    // 			label: 'Male/Female/Both',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Website',
    // 			label: 'Website',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'Facebook',
    // 			label: 'Facebook',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Instagram',
    // 			label: 'Instagram',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Twitter',
    // 			label: 'Twitter',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Youtube',
    // 			label: 'Youtube',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Linkedin',
    // 			label: 'Linkedin',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Snapchat',
    // 			label: 'Snapchat',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Go',
    // 			label: 'G+',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BusinessPackage',
    // 			label: 'Business Package',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'ServiceType',
    // 			label: 'Service Type',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'Brand',
    // 			label: 'Brand',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Sunday From to',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.FRIDAY == null
    // 								? ''
    // 								: `${calendar.SUNDAY.openTime}-${calendar.SUNDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Monday From to',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.MONDAY == null
    // 								? ''
    // 								: `${calendar.MONDAY.openTime}-${calendar.MONDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},
    // 		{
    // 			name: 'calendar',
    // 			label: 'Tuesday From To',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.TUESDAY == null
    // 								? ''
    // 								: `${calendar.TUESDAY.openTime}-${calendar.TUESDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Wednesday From To',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.WEDNESDAY == null
    // 								? ''
    // 								: `${calendar.WEDNESDAY.openTime}-${calendar.WEDNESDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Thursday From TO',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.THURSDAY == null
    // 								? ''
    // 								: `${calendar.THURSDAY.openTime}-${calendar.THURSDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Friday From To',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.FRIDAY == null
    // 								? ''
    // 								: `${calendar.FRIDAY.openTime}-${calendar.FRIDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},

    // 		{
    // 			name: 'calendar',
    // 			label: 'Saturday from To',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 				customBodyRender: (calendar, tableMeta) => {
    // 					return (
    // 						<div>
    // 							{calendar === undefined || calendar.SATURDAY == null
    // 								? ''
    // 								: `${calendar.SATURDAY.openTime}-${calendar.SATURDAY.endTime}`}
    // 						</div>
    // 					);
    // 				},
    // 			},
    // 		},
    // 	];

    // Service Providers-> Car Agents
    else if (this.props.match.params.type === 'CarsAgent') {
      columns = [
        {
          name: 'BusinessName',
          label: 'Business Name',
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'ServiceType',
          label: 'Service Type',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'BusinessLogo',
          label: 'Business Logo',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'PhoneNumber',
          label: 'Phone Number',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'WhatsappNumber',
          label: 'Whatsapp Number',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'BusinessCategory',
          label: 'Business Category',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'AboutCompany',
          label: 'About the Company',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'SelectLocationMap',
          label: 'Select Location on Map',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'Website',
          label: 'Website',
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: 'Website',
          label: 'Facebook',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Instagram',
          label: 'Instagram',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Twitter',
          label: 'Twitter',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Youtube',
          label: 'Youtube',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Linkedin',
          label: 'Linkedin',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Snapchat',
          label: 'Snapchat',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'Go',
          label: 'G+',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'BusinessPackage',
          label: 'Business Package',
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: 'id',
          label: 'Manage Categories',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (id, tableMeta) => {
              return (
                <div>
                  <Link
                    to={'/ServiceProviders/Agent/ManageCatagory'}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                  {/* <span
										// onClick={this.deleteUser.bind(this, id)}
										className='m-r-15 text-muted'
										data-toggle='tooltip'
										data-placement='top'
										title=''
										data-original-title='Delete'>
										<i className='f-20 icofont icofont-delete-alt text-danger'></i>{' '}
									</span> */}
                </div>
              );
            },
          },
        },

        {
          name: 'id',
          label: 'Manage Cars',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (id, tableMeta) => {
              return (
                <div>
                  <Link
                    to={'/ServiceProviders/Agent/ManageCars'}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                  {/* <span
										// onClick={this.deleteUser.bind(this, id)}
										className='m-r-15 text-muted'
										data-toggle='tooltip'
										data-placement='top'
										title=''
										data-original-title='Delete'>
										<i className='f-20 icofont icofont-delete-alt text-danger'></i>{' '}
									</span> */}
                </div>
              );
            },
          },
        },
        {
          name: 'id',
          label: 'Manage Showroom',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (id, tableMeta) => {
              return (
                <div>
                  <Link
                    to={'/ServiceProviders/Agent/ManageShowRoom'}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                  {/* <span
										// onClick={this.deleteUser.bind(this, id)}
										className='m-r-15 text-muted'
										data-toggle='tooltip'
										data-placement='top'
										title=''
										data-original-title='Delete'>
										<i className='f-20 icofont icofont-delete-alt text-danger'></i>{' '}
									</span> */}
                </div>
              );
            },
          },
        },
        {
          name: 'id',
          label: 'Manage Workshop',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (id, tableMeta) => {
              return (
                <div>
                  <Link
                    to={'/ServiceProviders/Agent/ManageWorkShop'}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                  {/* <span
										// onClick={this.deleteUser.bind(this, id)}
										className='m-r-15 text-muted'
										data-toggle='tooltip'
										data-placement='top'
										title=''
										data-original-title='Delete'>
										<i className='f-20 icofont icofont-delete-alt text-danger'></i>{' '}
									</span> */}
                </div>
              );
            },
          },
        },
      ];
    }

    // // Service Providers-> Car Agents-> Manage Categories
    // else if (this.props.match.params.type === 'CarsAgent') {
    // 	columns = [
    // 		{
    // 			name: 'CarBrand',
    // 			label: 'Business Name',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'CarModelSeriese',
    // 			label: 'Service Type',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BusinessLogo',
    // 			label: 'Business Logo',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'PhoneNumber',
    // 			label: 'Phone Number',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'whatsappnumber',
    // 			label: 'whatsapp number',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BuninessCotegory',
    // 			label: 'Business Category',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'AboutTheCompany',
    // 			label: 'About the Company',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'SelectLocationMap',
    // 			label: 'Select Location on Map',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'Website',
    // 			label: 'Website',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'Website',
    // 			label: 'Facebook',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Instagram',
    // 			label: 'Instagram',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Twitter',
    // 			label: 'Twitter',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Youtube',
    // 			label: 'Youtube',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Linkedin',
    // 			label: 'Linkedin',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Snapchat',
    // 			label: 'Snapchat',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'Go',
    // 			label: 'G+',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'BusinessPackage',
    // 			label: 'Business Package',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'ServiceType',
    // 			label: 'Manage Categories',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},

    // 		{
    // 			name: 'Brand',
    // 			label: 'Manage Cars',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'SundayFromto',
    // 			label: 'Manage Showroom',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 		{
    // 			name: 'MondayFromto',
    // 			label: 'Manage Workshop',
    // 			options: {
    // 				filter: false,
    // 				sort: true,
    // 			},
    // 		},
    // 	];
    // }
    const options = {
      filter: false,
      search: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving
            ? 'Loading data..!'
            : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${columns.label}`,
        },
      },
    };
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  {/* <div className='card-header'>

										<div className='row'>
											<div className='col-sm-9'>
												<FormControl
													variant='outlined'
													className='col-sm-2 mx-1'>
													<InputLabel
														htmlFor='outlined-age-native-simple'
														style={{ fontSize: '12px' }}>
														Service Type
													</InputLabel>
													<Select
														search
														native
														name=''
														value={this.state.serviceFilter}
														onChange={val =>
															this.handleServiceChange(val.target.value)
														}
														label='Time Peroid'
														className='my-2'
														style={{ height: '30px' }}
														inputProps={{
															name: 'Time Peroid',
															id: 'outlined-age-native-simple',
														}}>
														<option value='false'> </option>
														<option value='garage'>garages</option>
														<option value='Spare Parts'> Spare Parts</option>
														<option value='CarDealers'> CarDealers</option>
													</Select>
												</FormControl>

												<FormControl>
													<div
														className='btn btn-dark py-1 mx-3 mt-2'
														onClick={this.onGo}>
														Go
													</div>
												</FormControl>
											</div>
										</div>
									</div> */}

                  <div className="card-block">
                    {(() => {
                      const rows = Array.isArray(this?.props?.home)
                        ? this.props.home
                        : [];
                      const total = rows.length;
                      const activeMembership = rows.filter((r) => r?.daysLeft).length;
                      const expiredMembership = total - activeMembership;
                      const activeAccounts = rows.filter(
                        (r) => r?.status === 'active'
                      ).length;
                      const now = new Date();
                      const newThisMonth = rows.filter((r) => {
                        const d = r?.createdAt ? new Date(r.createdAt) : null;
                        return (
                          d &&
                          d.getMonth() === now.getMonth() &&
                          d.getFullYear() === now.getFullYear()
                        );
                      }).length;
                      const kpi = (label, value, color) => (
                        <div
                          style={{
                            flex: 1,
                            minWidth: 130,
                            background: '#f6f8fc',
                            borderRadius: 8,
                            padding: '0.9rem 1rem',
                            margin: '0 0.4rem 0.8rem',
                          }}
                        >
                          <div
                            style={{ fontSize: '1.6rem', fontWeight: 700, color }}
                          >
                            {value}
                          </div>
                          <div style={{ color: '#7b8aa5', fontSize: '0.82rem' }}>
                            {label}
                          </div>
                        </div>
                      );
                      return (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            marginBottom: '1rem',
                          }}
                        >
                          {kpi(
                            `Total ${this?.props?.match?.params?.type || ''}`,
                            total,
                            '#1b2a4e'
                          )}
                          {kpi('Active Membership', activeMembership, '#28a745')}
                          {kpi('Expired Membership', expiredMembership, '#e0a800')}
                          {kpi('Active Accounts', activeAccounts, '#3ab1f7')}
                          {kpi('New This Month', newThisMonth, '#6f42c1')}
                        </div>
                      );
                    })()}
                    <div className="dt-responsive table-responsive">
                      {/* <button
												className='f-right bg-white b-none'
												data-modal='modal-13'>
												<Tooltip
													title='Download Selected'
													aria-label='download'
													onClick={() => {
														this.exportCSVS();
													}}>
													<i
														className='icofont icofont-download-alt'
														style={{
															fontSize: '30px',
															color: 'grey',
														}}></i>
												</Tooltip>
											</button> */}
                      <div className="dt-responsive table-responsive">
                        {this.props.home !== undefined ? (
                          <MUIDataTable
                            title={`${this?.props?.match?.params?.type} List`}
                            className="table-responsive"
                            // data={(this?.state?.serviceFilter === undefined) ? this?.state?.list : this?.state?.serviceFilter}
                            data={this?.props?.home}
                            columns={columns}
                            options={options}
                          />
                        ) : (
                          <h4>Loading...</h4>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductList.propsTypes = {
  getGarageData: PropTypes.func.isRequired,
  getTaxiData: PropTypes.func.isRequired,
  SparePartsGetList: PropTypes.func.isRequired,
  getcardealerListing: PropTypes.func.isRequired,
  getcarsaleListing: PropTypes.func.isRequired,
  getCarRentListing: PropTypes.func.isRequired,
  GetServiceFilter: PropTypes.func.isRequired,
  getCarWashListing: PropTypes.func.isRequired,
  getcarInsuranceListing: PropTypes.func.isRequired,
  getdrivingSchoolListing: PropTypes.func.isRequired,
  getcarProtectionListing: PropTypes.func.isRequired,
  getairConditioningListing: PropTypes.func.isRequired,
  getquickServiceOwnerListing: PropTypes.func.isRequired,
  getCarTowingData: PropTypes.func.isRequired,
};

var mapStateToProps = (state) => {
  if (state.home.list.data !== undefined) {
    return {
      home: state.home.list.data,
    };
  } else {
    return {
      home: state.home.list,
    };
  }
};

export default connect(mapStateToProps, {
  getCarWashListing,
  getGarageData,
  getTaxiData,
  SparePartsGetList,
  getcardealerListing,
  getcarsaleListing,
  getCarRentListing,
  GetServiceFilter,
  getcarInsuranceListing,
  getdrivingSchoolListing,
  getcarProtectionListing,
  getairConditioningListing,
  getquickServiceOwnerListing,
  getCarTowingData,
  updateGarageStatus,
  updateBusinessStatus,
  deleteCarSale,
})(ProductList);
